import { cn } from '@/lib/utils.ts'
import { NavLink } from 'react-router-dom'

type Props = {
  text: string
  path: string
  className?: string
  activeClassName?: string
}

export const NavButton = ({ text, path, className, activeClassName }: Props) => {
  return (
    <NavLink
      to={path}
      end
      className={({ isActive }) =>
        cn(
          'h-10 gap-2 font-EN-KR-sub-heading-bold text-[#6091b5] hover:text-[#6091b5]/90',
          className,
          isActive &&
            cn('text-contents-onDarkPrimary hover:bg-transparent hover:text-contents-onDarkPrimary', activeClassName),
        )
      }
    >
      {text}
    </NavLink>
  )
}
